import { h, reactive, computed, Transition, renderSlot } from 'vue'
import './style.scss'


const AStepper = {
    name: 'AStepper',
    props: {
        modelValue: {
            required: true,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
    },
    setup: (props, ctx) => {
        const state = reactive({
            activeIndex: 0,
            activeContent: null,
            slots: ctx.slots.default()[0].children,
            isLast: false,
            transition: {
                dir: 'left',
                animated: false,
            }
        })

        const transitionName = computed(() => `a-transition--slide-${state.transition.dir}`)

        state.slots.forEach((row, i) => {

            if(row.props) {
                if (props.modelValue === row.props.name) {
                    row.props.show = true
                    state.activeIndex = i
                    state.activeContent = state.slots
                    ctx.emit('init', {index: state.activeIndex})
                }
            }
        })

        const next = () => {
            if(state.activeIndex + 1 > state.slots.length - 1) return
            state.transition.dir = 'left'
            goTo(state.activeIndex + 1)
        }

        const prev = () => {
            if(state.activeIndex - 1 < 0) return
            state.transition.dir = 'right'
            goTo(state.activeIndex - 1)
        }

        const goTo = (i) => {
            let numberKey = 0;
            for (let index in state.slots) {
                if(state.slots[index].key==i) {
                    numberKey = index;
                }

            }



            if(numberKey >= 0 && numberKey <= state.slots.length) {


                state.transition.dir = numberKey < state.activeIndex ? 'right' : 'left';
                state.isLast = numberKey + 1 === state.slots.length ? true : false;
                animated();
                state.activeIndex = +numberKey;
                state.slots.forEach(row => row.props.show = false);
                state.slots[state.activeIndex].props.show = true;
                state.activeContent = state.slots;
                ctx.emit('step', { index: state.activeIndex })
                ctx.emit('update:modelValue', state.slots[state.activeIndex].props.name)

            }

        }

        const renderContent = () => {
            let content = [];
            if(state.activeContent) {
                state.activeContent.forEach((row, i) => {
                    if (i === state.activeIndex) {
                        //row.key = i
                        content.push(row)
                    }
                })
            }
            return content
        }

        const animated = () => {
            state.transition.animated = true
            setTimeout(() => {
                state.transition.animated = false
            }, 350);
        }

        const renderView = () =>
            h('div', {
                class: ['a-stepper'],
            }, h('div', {
                class: ['a-stepper__inner'],
            }), [
                h('div', {
                    class: ['a-stepper__header'],
                }),
                h('div', {
                    class: ['a-stepper__body'],
                }, h('div', {
                    class: ['a-stepper__inner'],
                }), h('div', {
                    class: ['a-stepper__content', state.transition.animated ? 'a-stepper__content--animated' : ''],
                }, h(Transition, {
                        name: transitionName.value,
                    },
                        renderContent
                    )
                )),
                h('div', {
                    class: ['a-stepper__footer'],
                }, [
                    renderSlot(ctx.slots, 'footer')
                ]),
            ])

        return {
            renderView,

            state,
            next,
            prev,
            goTo,
        }
    },
    render() {
        return this.renderView()
    },
}

export { AStepper }
